<template>
  <div>
    <template v-if="eventView">
      <v-container fluid grid-list-lg>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card width="100%">
              <v-card-text
                class="grey lighten-5 resizable"
                :style="{width:'100%',height:height}"
                id="contVideo"
                ref="contVideo"
              >
                <resize-observer @notify="setWidth()"/>

                <youtube
                  id="youtube"
                  :video-id="videoId"
                  ref="youtube"
                  @ready="ready"
                  @playing="playing"
                  width="100%"
                  height="100%"
                />
                <v-tooltip left>
                  <template v-slot:activator="{ on }">
                    <v-btn
                      @click="getTime"
                      v-on="on"
                      small
                      absolute
                      dark
                      fab
                      bottom
                      right
                      color="success"
                    >
                      <v-icon>add</v-icon>
                    </v-btn>
                  </template>
                  <span>{{$t('addEvent')}}</span>
                </v-tooltip>
              </v-card-text>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
    </template>
    <template v-else>
      <div
        class="grey lighten-5 resizable"
        :style="{width:'100%',height:height}"
        id="contVideo"
        ref="contVideo"
      >
        <resize-observer @notify="setWidth()"/>

        <youtube
          id="youtube"
          :video-id="videoId"
          ref="youtube"
          @ready="ready"
          @playing="playing"
          width="100%"
          height="100%"
        />
      </div>
    </template>
  </div>
</template>

<script>
import { Youtube } from 'vue-youtube'
import { close } from 'fs'

export default {
  components: { Youtube },
  props: {
    src: {
      type: String,
      required: false,
      default: ''
    },
    time: {
      type: Number,
      required: false,
      default: 0
    },
    eventView: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data () {
    return {
      width: 0,
      newTime: false
    }
  },
  watch: {
    src (val) {
      if (val) {
        // if (val.includes('youtube')) {
        this.videoId = val.split('?v=')[1]
        // }
      }
    },
    time (val) {
      if (val && Number.isInteger(val) && !this.newTime) this.setTime(val)
      else this.newTime = false
    }
  },
  mounted () {
  },
  computed: {
    videoId () {
      if (this.src.includes('youtube')) { return this.src.split('?v=')[1] } else if (this.src.includes('youtu.be')) { return this.src.split('/')[this.src.split('/').length - 1] } else return ''
    },
    player () {
      return this.$refs.youtube.player
    },
    height () {
      return this.width * 0.56 + 'px' || '0px'
    }

  },
  methods: {
    setWidth () {
      if (this.$refs.contVideo && this.$refs.contVideo.clientWidth) { this.width = this.$refs.contVideo.clientWidth } else {
        setTimeout(() => {
          this.setWidth()
        }, 1000)
      }
    },
    playing () {
      // console.log('\o/ we are watching!!!')
    },
    getTime () {
      this.newTime = true
      this.player.pauseVideo()
      this.player.getCurrentTime().then(time => this.$emit('addEvent', time))
    },
    setTime (time) {
      this.player.seekTo(time > 5 ? time - 5 : 0)
      // if(pause) this.player.pauseVideo()
    },
    ready () {
      this.player.getDuration().then(duration => {
        this.setWidth()
        this.$emit('duration', Math.floor(duration))
      }
      )
    }
  }
}
</script>
